import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { AssetReaderService } from '@core/lp/asset-reader.service';
import { DataReaderService } from '@core/lp/data-reader.service';
import { LpStoryActivity } from '@typings/lp/generated';
import { LpStoryActivityComponent } from '../../lp/lp-story-activity/lp-story-activity.component';

@Component({
  selector: 'app-story-activity-test-page',
  imports: [LpStoryActivityComponent],
  templateUrl: './story-activity-test-page.component.html',
  styleUrl: './story-activity-test-page.component.css',
})
export class StoryActivityTestPageComponent implements OnInit {
  #dataReaderService = inject(DataReaderService);

  storyActivities = signal<LpStoryActivity[]>([]);
  selectedStoryIndex: WritableSignal<number> = signal(0);
  assetReader = inject(AssetReaderService);

  async ngOnInit() {
    this.storyActivities.set(await this.#dataReaderService.getInstancesByType('StoryActivity'));
  }

  protected changeSelectedStory(event: Event) {
    const target = event.target as HTMLSelectElement;
    const uid = target.value;
    if (uid === undefined) {
      return;
    }
    const index = this.storyActivities().findIndex((storyActivity) => storyActivity.uid === uid);
    if (index === -1) {
      return;
    }
    this.selectedStoryIndex.set(index);
  }
}
